import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';

export default class LifeLostPopup extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene, livesRemaining,lifeDisplayName) {
    super(scene);

    this.alpha = 0;
    this.scale = 0;

    const bg = ABCyaPhaser.Images.addImage(0,0,'select-popup-bg', this);
    bg.scale = 0.65;

    const lifeClip = ABCyaPhaser.Images.addImage(0,0,lifeDisplayName, this).setOrigin(0);
    const lifeTxt = ABCyaPhaser.Text.addText(0,0,`${45}pt`, 0x433c49, FontKeys._cloudy_with_a_chance_of_lovRg,` X ${livesRemaining}`,this, false).setOrigin(0);

    const totalWidth = lifeClip.width + lifeTxt.width + 20;
    const marginX = -totalWidth / 2;

    // positioning
    lifeClip.x = marginX;
    lifeClip.y = -(lifeClip.height / 2);
    lifeTxt.x = lifeClip.x + lifeClip.width + 10;
    lifeTxt.y = -(lifeTxt.height / 2);

    ABCyaPhaser.Tweens.addTween(this, 400, { alpha: 1, scale: 1, completeDelay: 1600 }, Phaser.Math.Easing.Linear, () => this.popUpComplete());
  }

  popUpComplete () {
    this.emit('LIVES_SHOWN');
    this.destroy();
  }
}